module.exports = __webpack_public_path__ + "static/media/dragisa.2a6cc17c.jpg";